// Date of birth is its own answer type (input_attributes[0].dob), shown as a calendar; the answer is saved as DD-MM-YYYY.

export function isDobQuestion(question) {
  return !!question?.input_attributes?.[0]?.dob;
}

// "17 years 4 months" as of today, or null when the date is missing, invalid or in the future
export function ageFromDob(answer) {
  const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(answer || "");
  if (!match) return null;
  const day = +match[1], month = +match[2], year = +match[3];
  const today = new Date();
  let years = today.getFullYear() - year;
  let months = today.getMonth() + 1 - month;
  if (today.getDate() < day) months--;
  if (months < 0) { years--; months += 12; }
  if (years < 0) return null;
  return `${years} year${years === 1 ? "" : "s"} ${months} month${months === 1 ? "" : "s"}`;
}
